/**
 * @file Builds the select options for every known timezone.
 */

import timezones from "timezones-list";

type TimeZoneOption = {
  label: string;
  value: string;
};

/**
 * Builds the list of timezone select options from the timezone code and name of each entry.
 */
const getTimeZoneOptions = (): TimeZoneOption[] => {
  const options = timezones.map(({ tzCode: value, name: label }) => ({ value, label }));

  return options;
};

export default getTimeZoneOptions;
